var p = function(e, r) {
  return p = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, t) {
    o.__proto__ = t;
  } || function(o, t) {
    for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
  }, p(e, r);
};
function l(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  p(e, r);
  function o() {
    this.constructor = e;
  }
  e.prototype = r === null ? Object.create(r) : (o.prototype = r.prototype, new o());
}
var s = function() {
  return s = Object.assign || function(e) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, s.apply(this, arguments);
};
function c(e, r) {
  var o = {};
  for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && r.indexOf(t) < 0 && (o[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, t = Object.getOwnPropertySymbols(e); n < t.length; n++)
      r.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[n]) && (o[t[n]] = e[t[n]]);
  return o;
}
function i(e, r, o) {
  if (arguments.length === 2) for (var t = 0, n = r.length, a; t < n; t++)
    (a || !(t in r)) && (a || (a = Array.prototype.slice.call(r, 0, t)), a[t] = r[t]);
  return e.concat(a || Array.prototype.slice.call(r));
}
export {
  s as __assign,
  l as __extends,
  c as __rest,
  i as __spreadArray
};
